<div [class]="'offer-recommendation-tile offer-recommendation-tile--' + cssClassSuffix">

    <div class="offer-recommendation-tile__header">
        <span class="offer-recommendation-tile__header__type">
          {{ getTranslationKey('header') | translate }}
        </span>
    </div>

    <div class="offer-recommendation-tile__details">

        <div class="offer-recommendation-tile__missing-recommendation-image">
            <img [src]="imageSrc" alt="">
        </div>

        <div class="offer-recommendation-tile__missing-recommendation-description"
            [innerHTML]="getTranslationKey('description') | translate | safeHtml">
        </div>

        <div class="offer-recommendation-tile__actions">
            <button class="btn btn--secondary btn--big"
                    (click)="contactWithUs()">
                {{ getTranslationKey('buttonLabel') | translate }}
            </button>
        </div>
    </div>

</div>
